import { PageLocatorMap } from '../types/PageLocatorMap';

export const applySearchYearPage = {
  footer: {
    root: 'apply-search-year-page.footer.root',
  },
  form: {
    accessibilitySubmit: 'apply-search-year-page.form.accessibility-submit',
    getRadioOption: (index: number): string =>
      `apply-search-year-page.form.radio-option-${index + 1}`,
    h1: 'apply-search-year-page.form.h1',
    h2: 'apply-search-year-page.form.h2',
    radioGroupRoot: 'apply-search-year-page.form.radio-group-root',
    root: 'apply-search-year-page.form.root',
  },
} as const satisfies PageLocatorMap;
